<script setup>
import { defineProps, defineEmits, computed } from "vue";
import TimeOffset from "@/components/ui/TimeOffset.vue";

const props = defineProps({
  modelValue: {
    type: Object,
    default: () => ({
      event: null,
      limit: null,
      send_offset_minutes: 0,
    }),
  },
  automaticEvents: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits(['update:modelValue']);

const displayOffset = computed(() => props.automaticEvents.find(e => e.value === props.modelValue.event)?.supportsOffset ?? false);

function update(key, value) {
  emit('update:modelValue', {
    ...props.modelValue,
    [key]: value,
  });
}
</script>
<template>
  <div>
    <div class="form-group">
      <label for="form-mkt-prop-automatic-event">{{ $t('Trigger Event') }}</label>
      <select id="form-mkt-prop-automatic-event"
              name="send_parameters[event]"
              class="form-control form-control-lg"
              :value="modelValue.event"
              @change="update('event', $event.target.value)"
              required>
        <option value=""></option>
        <option v-for="e in automaticEvents" :value="e.value">{{ e.name }}</option>
      </select>
    </div>
    <div class="form-group" v-if="displayOffset">
      <label for="form-mkt-prop-automatic-offset">{{ $t('Time Offset from Trigger Event') }}</label>
      <TimeOffset
        :modelValue="modelValue.send_offset_minutes"
        :inputClass="'form-control form-control-lg'"
        @update:modelValue="update('send_offset_minutes', $event)"
      ></TimeOffset>
      <small class="form-text text-muted">{{ $t('Offset can be negative or positive, 0 means immediate') }}</small>
      <input type="hidden" name="send_parameters[send_offset_minutes]" :value="modelValue.send_offset_minutes">
    </div>
    <div class="form-group">
      <label for="form-mkt-prop-automatic-limit">{{ $t('Maximum messages per recipient') }}</label>
      <input type="number"
             id="form-mkt-prop-automatic-limit"
             class="form-control form-control-lg"
             name="send_parameters[limit]"
             :value="modelValue.limit"
             @change="update('limit', $event.target.value ? parseInt($event.target.value) : null)"
             min="1"
             :placeholder="$t('Unlimited')">
      <small class="form-text text-muted">{{ $t('Leave empty for unlimited messages') }}</small>
    </div>
  </div>
</template>